<template>
  <div class="home">
    <van-sticky>
      <header>
        <img class="logo" :src="indexData.logoUrl && indexData.logoUrl != '' ? indexData.logoUrl : indexData.logoUrl" :alt="indexData.site_name || ''" />
        <form action="/">
          <van-search show-action placeholder="请输入搜索关键词" @click="go_search('/search')">
            <template #action>
              <div @click="go_search('/search')">搜索</div>
            </template>
          </van-search>
        </form>
      </header>
    </van-sticky>
	  <!-- <Img/> -->
    <div v-if="indexData && menuList.length > 0">
      <module :comData="moduleList" :indexData="indexData" :menuList="menuList"/>
    </div>
  </div>
</template>

<script>
import module from "./module.vue";
import Img from "@/components/img.vue";
import api from "@/request/api";
export default {
  name: "HomePage",
  data() {
    return {
      menuList: [],
      indexData: [],
      moduleList:[
        {
          id:1,
          moduleCode:'banner'
        },
        {
          id:2,
          moduleCode:'tool'
        },
        {
          id:3,
          moduleCode:'newList'
        },
        {
          id:4,
          moduleCode:'recommend'
        },
        {
          id:5,
          moduleCode:'shop'
        },
      ],
      logoUrl:require('@/static/images/nologin.png')
    };
  },
  components: {
    module,
	Img
  },
  created() {
    this.getHttp();
  },
  methods: {
    async getHttp() {
      try {
        const [IndexData, getCategoryData] = await Promise.all([
          this.getIndexData(),
          this.getCategory({is_good:1}),
        ]);
        if (getCategoryData.status === 200) {
          this.recommendList = getCategoryData.data;
          getCategoryData.data.unshift({
            cate_name: "全部",
            id: 0,
          },
          );
          
          this.menuList = getCategoryData.data;
        }
        if (IndexData.status === 200) {
			
          this.indexData = IndexData.data; console.log(111,this.indexData)
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getIndexData() {
      return api.getIndexData();
    },
    async getCategory(data) {
      return api.getCategory(data);
    },
    loadData(d) {
      this.index = d.id;
    },
    go_search(path) {
      this.$router.push({ path: path });
    },
    formatMilliseconds(milliseconds) {
      return milliseconds.toString().padStart(2, "0");
    },
  },
};
</script>
<style lang="scss">
@import "./index.scss";
.van-count-down,
.count_down {
  display: flex;
  align-items: center;
  justify-content: center;
  .colon {
    display: inline-block;
    margin: 0 0.05rem;
    color: var(--bg2);
  }
  .block {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.35rem;
    height: 0.35rem;
    color: #000;
    font-size: 0.22rem;
    font-weight: 400;
    text-align: center;
    background: linear-gradient(#ffa06a, #f8cc85);
    border-radius: 0.05rem;
  }
}
</style>
